import FaviconBaseController from "./favicon_base_controller.js";

export default class extends FaviconBaseController {
  static targets = [
    "imageFileInputDropper",
    "imageFileInput",
    "dropSection",
    "cropSection",
    "croppedImage",
    "cropperImageContainer",
    "loader",
    "errorMessage",
  ];

  initialize() {
    super.initialize()
    this.cropperSection = $(this.cropSectionTarget);
    this.cropperImageContainer = this.cropperSection.find(
      ".media__cropper-image-container"
    );
    this.croppedImageSelector = this.cropperSection.find("#cropped-image");
    this.imageFileInputTarget.title = "";
    this.imageFileInputDropperTarget.title = "";
  }

  handleClick(e) {
    if (e.target.id === "favicon-input-dropper") {
      e.preventDefault();
    }
  }

  addFile(e) {
    this.handleAddFile(e, this.initializeFaviconCropper.bind(this));
  }

  cancel() {
    this.goBack(this.cropSectionTarget, this.dropSectionTarget);
    this.imageFileInputTarget.value = "";
    this.imageFileInputDropperTarget.value = "";
    this.fileUploadCropper.reset_zoom_slider();
  }

  save() {
    this.applyFavicon(
      this.fileUploadCropper,
      this.croppedImageSelector,
      this.getImageName()
    );
    this.showProcessingLoader();
  }

  getImageName() {
    return this.imageFileInputTarget.value
      ? this.imageFileInputTarget.files[0].name
      : this.imageFileInputDropperTarget.files[0].name;
  }

  isValidFileType(fileType) {
    return [
      "image/jpg",
      "image/jpeg",
      "image/png",
      "image/svg+xml",
      "image/x-icon",
      "image/vnd.microsoft.icon",
    ].includes(fileType);
  }
}
